import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { WifiOff, Wifi, UploadCloud } from "lucide-react";
import { countPending } from "../lib/offlineQueue";

export function ConnectionBanner() {
  const [online, setOnline] = useState(navigator.onLine);
  const [pending, setPending] = useState(0);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    const refresh = () => countPending().then(setPending);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    window.addEventListener("offline-queue-changed", refresh);
    refresh();
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
      window.removeEventListener("offline-queue-changed", refresh);
    };
  }, []);

  if (online && pending === 0) return null;

  return (
    <div className="no-print" data-testid="connection-banner">
      {!online && (
        <div className="bg-[#CE1126] text-white text-sm px-4 py-2 flex items-center justify-center gap-2" data-testid="offline-banner">
          <WifiOff className="w-4 h-4" /> Sin conexión — puedes preparar reportes; se enviarán al volver el internet.
        </div>
      )}
      {pending > 0 && (
        <Link to="/pendientes" data-testid="pending-banner"
          className="bg-[#FFD100] text-[#7A5E00] text-sm px-4 py-2 flex items-center justify-center gap-2 font-semibold hover:bg-[#ffd933]">
          {online ? <Wifi className="w-4 h-4" /> : <UploadCloud className="w-4 h-4" />}
          Reportes pendientes: {pending} · {online ? "Enviar ahora" : "Esperando conexión"}
        </Link>
      )}
    </div>
  );
}
